import React, { useEffect, useState, useRef } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './Carousel.css';
import { Container } from 'react-bootstrap';
import axios from 'axios';

const Carousels = () => {
  const [infob, setInfob] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/carousel/lister`)
      .then(res => {
        setInfob(res.data);
      })
      .catch(() => {});
  }, []);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <Container className="hd-carousel-wrapper px-0">
      <Carousel 
        ref={carouselRef}
        fade 
        controls={false} 
        indicators={false}
        interval={5000}
        className="hd-carousel-modern"
        activeIndex={activeIndex}
        onSelect={handleSelect}
      >
        {infob.map((info, idx) => (
          <Carousel.Item key={idx} className="hd-carousel-item">
            <div className="hd-carousel-image-container">
              <img
                className="hd-carousel-image"
                src={info.image}
                alt={`slide-${idx}`}
              />
              <div className="hd-carousel-image-overlay"></div>
              
              {(info.titre || info.description) && (
                <div className={`hd-carousel-caption ${activeIndex === idx ? 'hd-carousel-active' : ''}`}>
                  {info.titre && <h3 className="hd-carousel-title">{info.titre}</h3>}
                  {info.description && <p className="hd-carousel-description">{info.description}</p>}
                  {info.bouton && (
                    <button className="hd-carousel-button">
                      {info.bouton}
                    </button>
                  )}
                </div>
              )}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
      
      <div className="hd-carousel-custom-indicators">
        {infob.map((_, idx) => (
          <div 
            key={idx}
            className={`hd-carousel-custom-indicator ${activeIndex === idx ? 'hd-carousel-active' : ''}`}
            onClick={() => setActiveIndex(idx)}
          >
            <div className="hd-carousel-indicator-progress"></div>
          </div>
        ))}
      </div>
      
      <button 
        className="hd-carousel-control-prev" 
        onClick={() => carouselRef.current.prev()}
      >
        <span className="hd-carousel-control-prev-icon" aria-hidden="true">‹</span>
      </button>
      <button 
        className="hd-carousel-control-next" 
        onClick={() => carouselRef.current.next()}
      >
        <span className="hd-carousel-control-next-icon" aria-hidden="true">›</span>
      </button>
    </Container>
  );
};

export default Carousels;